import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isEqual', (values, value, validtext) => {
  return value === validtext
})
